import React from 'react';
import { AlertCircle, ArrowLeft, RefreshCcw } from 'lucide-react';

const SentryFallback = ({ error, resetError }) => {
    
    const handleHomeClick = () => {
        window.location.href = '/';
    };

    const handleReload = () => {
        window.location.reload();
    };

    return (
        <div className="min-h-screen bg-neutral-900 flex flex-col justify-center items-center px-4 font-sans text-center">
            <div className="bg-neutral-800 p-8 rounded-2xl shadow-2xl max-w-md w-full border border-neutral-700">
                <div className="w-16 h-16 bg-red-500/10 text-red-500 rounded-full flex items-center justify-center mx-auto mb-6">
                    <AlertCircle size={32} />
                </div>
                
                <h1 className="text-2xl font-bold text-white mb-2 font-display">
                    Oups, un imprévu !
                </h1>
                
                <p className="text-neutral-400 mb-8 text-sm">
                    Une erreur technique s'est produite. Notre équipe a été avertie et traite le problème right now.
                </p>

                {import.meta.env.DEV && error && (
                    <div className="mb-6 p-4 bg-neutral-900 rounded-lg text-left overflow-auto text-xs text-red-400 font-mono border border-red-500/20">
                        {error.message || 'Erreur inconnue'}
                    </div>
                )}

                <div className="flex flex-col sm:flex-row gap-3">
                    <button
                        onClick={handleHomeClick}
                        className="flex-1 flex justify-center items-center gap-2 px-4 py-2.5 bg-neutral-700 hover:bg-neutral-600 text-white rounded-lg font-medium transition-colors"
                    >
                        <ArrowLeft size={18} />
                        Retour au site
                    </button>
                    
                    <button
                        onClick={handleReload}
                        className="flex-1 flex justify-center items-center gap-2 px-4 py-2.5 bg-indigo-600 hover:bg-indigo-500 text-white rounded-lg font-medium transition-colors"
                    >
                        <RefreshCcw size={18} />
                        Réessayer
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SentryFallback;
